import { render } from "./IntroducePage.vue?vue&type=template&id=02a0f93c&scoped=true"
import script from "./IntroducePage.vue?vue&type=script&lang=js"
export * from "./IntroducePage.vue?vue&type=script&lang=js"

import "./IntroducePage.vue?vue&type=style&index=0&id=02a0f93c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a0f93c"]])

export default __exports__